import React from 'react';
import {
  TooltipContent,
  TooltipTitle,
  TooltipEventItem,
  EventName,
  EventId,
} from './TooltipStyles';
import { FlowEvents } from '../../types';

interface TooltipProps {
  type: 'start' | 'success' | 'error';
  events: FlowEvents;
}

const EventTooltip: React.FC<TooltipProps> = ({ type, events }) => {
  const getContent = () => {
    switch (type) {
      case 'start':
        if (!events?.start_event) return 'No start event configured';
        return (
          <TooltipEventItem>
            <EventName title={events?.start_event.name}>{events?.start_event.name}</EventName>
          </TooltipEventItem>
        );

      case 'success':
        if (!events?.success_event) return 'No success event configured';
        return (
          <TooltipEventItem>
            <EventName title={events?.success_event.name}>{events?.success_event.name}</EventName>
          </TooltipEventItem>
        );

      case 'error':
        if (!events.error_event?.length) return 'No error events configured';
        return events.error_event.map((event) => (
          <TooltipEventItem key={event.id}>
            <EventName>{event.name}</EventName>
          </TooltipEventItem>
        ));

      default:
        return null;
    }
  };

  const getTitle = () => {
    switch (type) {
      case 'start':
        return 'Initial Mapped Events';
      case 'success':
        return 'Complete Mapped Events';
      case 'error':
        return 'Error Mapped Events';
      default:
        return '';
    }
  };

  return (
    <TooltipContent>
      <TooltipTitle>{getTitle()}</TooltipTitle>
      {getContent()}
    </TooltipContent>
  );
};

export default EventTooltip;
